import * as React from "react";
import { isEqual } from "lodash";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { TUseXElement, useXElement } from "../../../hooks/useXElement";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import {
  IXCarouselProps,
  TXCarouselProps,
  XCarouselProps,
} from "../../../utils/interfaces/containers/XCarousel.interfaces";
import { XElementConfig } from "../../../utils/interfaces/Elements/XElement.interfaces";
import XCarouselCore from "./core";
import { TDynamicXElement } from "../../../utils/types/core/DynamicXElement";

import XStack from "../XStack/prod";
import XImage from "../../elements/XImage";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XCarousel: React.FC<XCarouselProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<TXCarouselProps>>(
      config.index
    );

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXCarouselProps>(
      value as any,
      breakpoint
    );

    return (
      <XStack config={config}>
        <XCarouselCore
          index={config.index}
          props={valueAtBreakPoint}
          DynamicXElement={DynamicXElement}
        />
      </XStack>
    );
  },
  compareProps
);

export default XCarousel;

const DynamicXElement: TDynamicXElement = React.memo(({ index, hierachy }) => {
  const { xElement: element, setXElement } =
    useXElement<TUseXElement<any>>(index);

  const xElement = element ?? {};

  React.useEffect(() => {
    setXElement({
      ...xElement,

      hierachy: hierachy + "-" + xElement.name,
    });
  }, [index]);

  switch (xElement.name) {
    case "XStack":
      return <XStack config={{ index }} />;
    case "XImage":
      return <XImage config={{ index }} />;

    default:
      return null;
  }
}, compareProps);
